// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarsHolder_stars__29izi"};